{
  "help": "Hjelp",
  "info": "Informasjon"
}
